export const cookiesKey = process.env.GATSBY_COOKIES_LS_KEY;
export const backendUrl = process.env.GATSBY_BACKEND_URL;
export const freshmailApiKey = process.env.GATSBY_FRESHMAIL_API_KEY;
export const freshmailApiSecret = process.env.GATSBY_FRESHMAIL_API_SECRET;
export const freshmailApiToken = process.env.GATSBY_FRESHMAIL_API_TOKEN;
export const freshmailApiUrl = process.env.GATSBY_FRESHMAIL_API_URL as unknown as URL;
export const apiUser = process.env.GATSBY_API_USER;
export const apiPassword = process.env.GATSBY_API_PASSWORD;
export const gtagId = process.env.GATSBY_GTAG_ID;
export const linkedinPartnerId = process.env.GATSBY_LINKEDIN_PARTNER_ID;
